import { render, staticRenderFns } from "./thirdLogin.vue?vue&type=template&id=8cc01844"
import script from "./thirdLogin.vue?vue&type=script&lang=js"
export * from "./thirdLogin.vue?vue&type=script&lang=js"
import style0 from "./thirdLogin.vue?vue&type=style&index=0&id=8cc01844&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports